import { useContext } from 'react'

import { StoreSettingsContext } from 'store/StoreSettingsContext'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type LogoProps = WithClassName

export const Logo = ({ className }: LogoProps) => {
	const storeCtx = useContext(StoreSettingsContext)

	return (
		<>
			{storeCtx?.storeSettings?.logo ? (
				<img
					className={cn('mx-auto my-0 max-h-16', className)}
					src={storeCtx?.storeSettings?.logo}
				/>
			) : (
				<div
					className={cn(
						'mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-tundora text-white',
						className
					)}>
					<h2>logo</h2>
				</div>
			)}
		</>
	)
}
